'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { X } from 'lucide-react';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Check localStorage only on client side after mount
    const hasConsent = localStorage.getItem('cookieConsent');
    setIsVisible(!hasConsent);
    setIsLoaded(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  // Don't render anything until we've checked localStorage
  if (!isLoaded || !isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-standard backdrop-blur-lg bg-bg-primary/95 shadow-lg"
      data-no-animation="true"
      style={{ opacity: 1, transform: 'none' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-5" data-no-animation="true">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-no-animation="true">
          <div className="flex-1" data-no-animation="true">
            <p className="body-md" data-no-animation="true" style={{ opacity: 1, transform: 'none' }}>
              We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.{' '}
              <Link 
                href="/terms" 
                className="text-accentcolourteal hover:underline font-semibold"
                data-no-animation="true"
              >
                Read our policy
              </Link>
            </p>
          </div>
          
          <div className="flex items-center gap-3 w-full sm:w-auto" data-no-animation="true">
            <button
              onClick={handleAccept}
              className="btn flex-1 sm:flex-initial px-6 py-2 bg-accentcolourteal text-white hover:bg-accentcolourteal/90 transition-colors"
              data-no-animation="true"
              style={{ opacity: 1, transform: 'none' }}
            >
              Accept
            </button>
            <button
              onClick={handleClose}
              className="p-2 hover:bg-white/10 rounded-lg transition-colors"
              aria-label="Close banner"
              data-no-animation="true"
              style={{ opacity: 1, transform: 'none' }}
            >
              <X className="w-5 h-5 text-text-secondary" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}